// LuxuryPage.jsx
import React from "react";
// import "./LuxuryPage.css";
import "../App.css";
import { useEnquiryModal } from "./EnquiryModal";
import { FaLocationDot } from "react-icons/fa6";
import { ENQUIRY_CTA } from "../constants";

const LuxuryPage = () => {
  const { openModal } = useEnquiryModal();
  return (
    <div id="about" className="luxury-page">
      {/* ----------- Section 1: Luxury Launch ----------- */}
      <section className="luxury-section">
        <div className="luxury-image">
          <img
            src="Assets/gallery4.webp"
            alt="Luxury View" 
          />
        </div>
        <div className="luxury-text">
          <h2 className="font-semibold">
            Hudayriyat Island by Modon
          </h2>
          <div className="luxury-location flex items-center">
            <FaLocationDot className="text-[#997736] mr-2" />
            <span className="text-[#997736] font-bold text-lg">Al Mamzar</span>
          </div>
          <p>
            Hudayriyat Island by Modon Properties is an exclusive waterfront destination in Abu Dhabi, spanning 11.6 square miles with a stunning 9.9-mile coastline. The island features two premium communities — Nawayef and Al Naseem — offering luxurious villas and mansions with breathtaking Arabian Gulf views. Nawayef presents elegant 3-7 bedroom villas and 6-8 bedroom mansions, while Al Naseem showcases California-style and Art Nouveau residences. Residents enjoy world-class amenities including infinity pools, private spas, cinemas, gyms, and landscaped surroundings. With prime connectivity, upscale living, and strong investment potential, Hudayriyat Island defines luxury island living in Abu Dhabi.
          </p>
          <button onClick={() => openModal(ENQUIRY_CTA.INTRO)} className="mt-4 font-semibold border-2 rounded-md border-[#997736] text-[#997736] hover:text-white px-6 py-2 hover:bg-[#997736] transition">DOWNLOAD BROCHURE</button>
        </div>
      </section>
    </div>
  );
};

export default LuxuryPage;
